import { Box } from "@mui/material";
import React from "react";

const Offset = ({ height }) => {
	return <Box height={height} sx={{ position: "sticky", top: 0 }}></Box>;
};

export default Offset;
